import { z } from 'zod'
import type { PriorArt, SavedSection } from '@packages/utilities/schemas'
import type { TableFieldValue } from './constants'
export type { ColoredHighlightCount } from '@packages/utilities/utils'

export interface SelectOption<T = string | number> {
  label: string
  value: T
}

export type MultiSelectOption<T = string | number> = SelectOption<T> & {
  description?: string
  level?: string
  not?: boolean
}

export type MultiSelectOptionWithEntities = MultiSelectOption & {
  relatedEntities: Array<{ name: string; selected: boolean }>
}

export type TableFieldOption = SelectOption<TableFieldValue> & {
  manageLabel: string
  width?: number
  center?: boolean
  default: boolean
}

export type SearchType = 'ai' | 'partner'

export interface CPCDetails {
  patent: string
  cpc: Array<Record<string, string[]>>
  initialSymbol?: string
  symbols: string[]
}

export type ResultsTab = 'results' | 'saved' | 'hidden'
export type SavedSectionAction = 'saved-section'

export type PriorArtUpdate = 'save' | 'remove-saved' | 'hide' | 'restore'

export interface UpdateResultParameters {
  updateType: PriorArtUpdate
  patent: string
  additionalPatents?: string[]
  callbackPatent?: string
  position?: number
  savedSections?: SavedSection[]
  switchTabOnSuccess?: boolean
  action?: SavedSectionAction
}

export interface FetchDetailsParameters {
  scroll: boolean
  withActions: boolean
  patentNumber: string
  itemType: PriorArt['itemType']
}

export interface CPCGroupings {
  key: string
  values: string[]
}

export interface ThemeOptions {
  updatedDesign: boolean
  darkMode: boolean
}

export const themeSchema = z.object({
  updatedDesign: z.boolean().default(true),
  darkMode: z.boolean().default(false),
})

export interface FileDetails {
  file: string | ArrayBuffer | null
  name: string
}

export interface FileApiDetails {
  file_url: string
  file_name: string
}

export type ClaimScopes = 'independent' | 'dependent'

export interface ClaimNumbersDetails {
  claimScope: ClaimScopes
  claimNumber: number
}
